import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import Link from "next/link";
import { Col, Container, Row } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import server from "../../api/server";
import ejjadhLogo from "@/src/assets/images/svg/nour-seen-logo.png";
import arrow from "../../assets/images/svg/arrow-up.svg";
import emailIcon from "../../assets/images/svg/email.svg";
import location from "../../assets/images/svg/location.svg";
import call_calling from "../../assets/images/svg/call_calling.svg";
import Swal from "sweetalert2";
import { handleImage } from "../handlers";
import { buildWhatsAppUrl } from "../../utils/whatsapp.mjs";

const Footer = ({ data }) => {
  const { locale } = useRouter();
  const { formatMessage } = useIntl();
  const socials = data?.socials;
  // ?.filter((link) =>
  //   ["instagram", "twitter", "facebook"]?.includes(link?.socialType?.name?.en)
  // );

  const [email, setEmail] = useState(" ");
  const [emailMessage, setEmailMessage] = useState(" ");

  useEffect(() => {
    setEmailMessage(formatMessage({ id: "email" }));
  }, [locale, formatMessage]);

  useEffect(() => {
    const scrollProcess = () => {
      let scrollPos = 700;
      const ScrollBtn = document?.querySelector(".scrollTop");
      function checkPosition() {
        let windowY = window.scrollY || 0;
        if (windowY > scrollPos) {
          // Scrolling UP
          ScrollBtn.classList.add("active");
        } else {
          // Scrolling DOWN
          ScrollBtn.classList.remove("active");
        }
        // scrollPos = windowY;
      }
      window.addEventListener("scroll", checkPosition);
    };

    scrollProcess();
  });

  const scrolly = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    await server.post("/pages/subscribers/sections", {
      section: { email: email },
    });
    Swal.fire(
      `${formatMessage({
        id: "thanks",
      })}`,
      `${formatMessage({
        id: "thankMsg",
      })}`,
      "success"
    );
    event.target.email.value = "";
  };
  const renderSocial = socials?.map((social, k) => (
    <Link
      href={social?.link}
      key={"info" + k}
      target={"_blank"}
      aria-label="social-link"
    >
      <Image src={social?.image} width={20} height={20} alt="social-icon" />
    </Link>
  ));

  return (
    <>
      <footer className="main-footer wrapper ">
        <div className="footer-top">
          <Row>
            <Col className="text-center">
              <div className="form-wrapper">
                <form onSubmit={onSubmit}>
                  {/* <span className="footer-news">
                                        <span>
                                            <FormattedMessage id="list" />
                                        </span>
                                        <span className="unique-bold color-main">
                                            <FormattedMessage id="newsletter" />
                                        </span>
                                    </span>
                                    <input
                                        type="email"
                                        className="form-control"
                                        placeholder={emailMessage}
                                        name="email"
                                        id="email"
                                        required={true}
                                        onChange={(e) => {
                                            setEmail(e?.target?.value);
                                        }}
                                        autoComplete="email"
                                    />
                                    <button className="send btn gradient-btn">
                                        <FormattedMessage id="subscribe" />
                                    </button> */}
                  <div className="rounded-5 whatsapp">
                    <Link
                      href={buildWhatsAppUrl(data?.siteInfo?.whatsup)}
                      aria-label="whatsapp"
                    >
                      <FormattedMessage id="send-whatsapp" />
                    </Link>
                  </div>
                </form>
              </div>
            </Col>
          </Row>
          <Container>
            <Row className="logo-social-div ">
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={5}
                xl={5}
                xxl={5}
                className=" d-flex flex-column justify-content-center align-items-center gap-4"
              >
                <div className="logo-wrapper d-flex flex-column justify-content-center align-items-start gap-3">
                  <div className="logo ">
                    <Link href="/" aria-label="app-logo">
                      <Image
                        src={handleImage(data?.siteInfo?.appLogo)}
                        width="100"
                        height="123"
                        alt={data?.siteInfo?.appName}
                      />
                    </Link>
                  </div>
                  <p>{data?.siteInfo?.appDesc?.[locale]}</p>
                </div>
                <div className=" social-div w-100">
                  <div className=" socials">{renderSocial}</div>
                </div>
              </Col>
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={3}
                xl={3}
                xxl={3}
                className=" links-wrapper "
              >
                <span className="fw-bold h3 text-start mb-3">
                  <FormattedMessage id="links" />
                </span>
                <div className="links-container">
                  {[
                    "home",
                    "recruitmentCountries",
                    "personnel",
                    "recruitmentRequest",
                    "blogs",
                    "about-us",
                    "faq",
                    "contact-us",
                    "privacyPolicy",
                    "termsConditions",
                  ]?.map((item, index) => (
                    <div key={index} className="link-item">
                      <Link
                        href={item === "home" ? "/" : `/${item}`}
                        legacyBehavior
                      >
                        <a aria-label="link-item">
                          <FormattedMessage id={item} />
                        </a>
                      </Link>
                    </div>
                  ))}
                </div>
              </Col>
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={4}
                xl={4}
                xxl={4}
                className="scrollTop-wrapper d-flex align-items-start justify-content-start mt-4 p-0"
              >
                <div className="contact-info pb-0 ms-0 d-flex flex-column justify-content-center align-items-start">
                  <ContactsElements initdata={data} locale={locale} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div className="footer-bottom">
          <Row className="align-items-center justify-content-between">
            <Col xs="12" md="4" className="m-auto m-lg-0">
              <div className="social d-flex text-center">
                {/* <FormattedMessage id="rights" /> */}
                {data?.siteInfo?.copyright?.[locale]}
              </div>
            </Col>
            <Col xs="12" md="4" className="m-auto m-lg-0">
              {/* <div className="social d-flex">{renderSocial}</div> */}
            </Col>

            <Col xs="12" md="4">
              <p className="developed-by text-center gap-1 align-items-center">
                <span>
                  <FormattedMessage id="developed" />
                </span>
                <Link
                  href="https://nsn.sa/"
                  target="_blank"
                  aria-label="logo-nsn"
                >
                  <Image
                    src={ejjadhLogo}
                    alt="ejjadh logo"
                    width={50}
                    height={40}
                    style={{ objectFit: "contain" }}
                  />
                </Link>
                {/* <FormattedMessage id="rights-reserved" /> */}
                {/* {data?.siteInfo?.copyright?.[locale]} */}
                {/* |
                <Link
                  href="https://ejjadh.sa/"
                  target="_blank"
                  className="text-white"
                >
                  <FormattedMessage id="contact" />
                </Link> */}
              </p>
            </Col>
          </Row>
        </div>
        <button
          onClick={scrolly}
          className="scrollTop"
          type="button"
          aria-label="up-button"
        >
          <Image src={arrow.src} width={10} height={20} alt="up-button" />
        </button>
        <a
          href={`tel:${data?.siteInfo?.phone}`}
          className="float phone"
          target="_blank"
          rel="noreferrer"
          aria-label="whatsapp"
        >
          <div className="my-float">
            <Image
              {...call_calling}
              alt="calling-icon"
              width={35}
              height={35}
            />
          </div>
        </a>
        <a
          href={buildWhatsAppUrl(data?.siteInfo?.whatsup)}
          className="float"
          target="_blank"
          rel="noreferrer"
          aria-label="whatsapp"
        >
          <div className="my-float">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              fill="#fff"
              width="60%"
            >
              <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path>
            </svg>
          </div>
        </a>
      </footer>
    </>
  );
};

export default Footer;

export const ContactsElements = ({ initdata, locale }) => {
  return (
    <>
      <div className="contact-element">
        <div className="icon">
          <Image src={emailIcon} alt="email-icon" />
        </div>
        <div className="contact-details">
          <p className="unique-bold">
            <FormattedMessage id="email" />
          </p>
          <p>
            <Link
              href={`mailto:${initdata?.siteInfo?.email}`}
              aria-label="email-link"
            >
              {initdata?.siteInfo?.email}
            </Link>
          </p>
        </div>
      </div>
      <div className="contact-element">
        <div className="icon">
          <Image src={call_calling} alt="calling-link" />
        </div>
        <div className="contact-details">
          <p className="unique-bold">
            <FormattedMessage id="phone" />
          </p>
          <p>
            <Link
              href={`tel:${initdata?.siteInfo?.phone}`}
              aria-label="phone-link"
            >
              {initdata?.siteInfo?.phone}
            </Link>
          </p>
        </div>
      </div>
      <div className="contact-element">
        <div className="icon">
          <Image src={location} alt="location" />
        </div>
        <div className="contact-details">
          <p className="unique-bold">
            <FormattedMessage id="address" />
          </p>

          <a
            href={initdata?.siteInfo?.locationAddress?.link || ""}
            target="_blank"
            rel="noopener noreferrer"
            className="map-link"
          >
            {initdata?.siteInfo?.locationAddress?.title?.[locale] ||
              (locale === "ar"
                ? "العنوان على الخريطة"
                : "View location on map")}
          </a>
        </div>
      </div>
    </>
  );
};
